import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMyOskLectureAttendanceListVm } from '../my-osk-lecture-attendance-models.model';

/** The lecture days of a group with the number of students present, the latest first. */
@Injectable({ providedIn: 'root' })
export class MyOskLectureAttendanceListsService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskLectureAttendanceLists`;
  }

  get(lectureGroupGuid: string): Observable<IMyOskLectureAttendanceListVm[]> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (lectureGroupGuid !== undefined && lectureGroupGuid !== null) {
      params = params.set('lectureGroupGuid', String(lectureGroupGuid));
    }
    return this.http.get<IMyOskLectureAttendanceListVm[]>(this.baseUrl, { headers, params });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
